/* src/views/Login/LoginView.js */
import { ref, nextTick } from 'vue' 
import { authService } from '@/services/auth'
import { useRouter } from 'vue-router'
import { pushService } from '@/services/pushService'
import api from '@/services/api' // <--- IMPORTANTE: Importa la tua istanza axios

export default {
  name: 'LoginView',
  
  setup() {
    const username = ref('')
    const password = ref('')
    const errorMessage = ref('')
    const loading = ref(false)
    const router = useRouter()
    const mediaBase = process.env.VUE_APP_MEDIA_BASE_URL

    async function handleLogin() {
      try {
        loading.value = true; // Ottima pratica attivare il loading
        const res = await authService.login(username.value, password.value)
        const token = res.token || (res.data && res.data.token)
        
        if (token) {
          localStorage.setItem('user-token', token)
          
          // --- NUOVO: Iscrizione al servizio Push ---
          try {
            console.log("➡️ Login riuscito, inizializzo notifiche push...");
            await pushService.subscribeUser(api);
            localStorage.setItem('device-registered', 'true');
          } catch (pushErr) {
            console.error("Errore iscrizione push (non bloccante):", pushErr);
          }
          // ------------------------------------------

          await nextTick()
          await new Promise(resolve => setTimeout(resolve, 50))
          console.log("➡️ Reindirizzamento sicuro verso user-menu...");
          router.push({ name: 'user-menu' })
        } 
        else {
          console.error("Il server non ha restituito nessun token valido.")
        }
      } 
      catch (error) {
        console.error("Errore durante il login:", error)
        alert("Errore durante il login: " + (error.message || JSON.stringify(error)))
      } finally {
        loading.value = false;
      }
    }

    return {
      logoUrl: '/media/logos/Logo.svg',
      errorMessage,
      handleLogin,
      loading,
      password,
      username,
    }
  }
}